import { Component, cloneElement } from 'react'
import { observer } from 'mobx-react'
import ReactDOM from 'react-dom'

import * as h from 'h'
import $ from 'jquery'

import styles from './styles.scss'

/*
 * This component animates row/column (or flex-direction) changes. It uses the
 * FLIP technique.
 *
 * https://medium.com/developers-writing/animating-the-unanimatable-1346a5aab3cd#.mcoo1peo7
 */

@observer
export default class AnimatedFlex extends Component {
  componentWillUpdate () {
    this.positions = {}
    this.props.children.forEach(el => {
      let $el = $(ReactDOM.findDOMNode(this.refs[el.key]))
      const { left: x, top: y } = $el.offset()
      this.positions[el.key] = { x, y }
    })
  }

  componentDidUpdate () {
    const $container = $(this.refs.container)
    const { children, animationDuration, direction, theme } = this.props

    let step1 = () => {
      $container.children().css('transition-duration', '0')
      this.flipDirection(direction, theme.row, theme.column)

      children.filter(el => el.key in this.positions).forEach(el => {
        let $el = $(ReactDOM.findDOMNode(this.refs[el.key]))
        const { left: x1, top: y1 } = $el.offset()
        const { x: x0, y: y0 } = this.positions[el.key]
        $el.css('transform', `translate(${x0 - x1}px, ${y0 - y1}px)`)
      })
    }

    let step2 = () => {
      $container.children().css('transition-duration', `${animationDuration}ms`)
      $container.children().css('transform', `translate(0, 0)`)
    }

    let step3 = () => {
      $container.children().css('transition-duration', '')
      $container.children().css('transform', '')
    }

    step1()
    /* Two frames need to pass on some browsers (mainly Firefox it appears)
     * before the second step starts. */
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(step2)
    })
    const minimumTimerStep = 20
    setTimeout(step3, animationDuration + minimumTimerStep)
  }

  flipDirection (direction, customRow, customColumn) {
    if (direction === 'row') {
      $(this.refs.container).removeClass(styles.column)
      $(this.refs.container).removeClass(customColumn)
      $(this.refs.container).addClass(customRow)
    } else if (direction === 'column') {
      $(this.refs.container).addClass(styles.column)
      $(this.refs.container).removeClass(customRow)
      $(this.refs.container).addClass(customColumn)
    }
  }

  render () {
    return h.div({
      ...h.ca([styles.container, this.props.theme.container]),
      ref: 'container'
    },
      // Cloning elements is required to get a DOM reference to them.
      this.props.children.map(element =>
        cloneElement(element, { ref: element.key })
      )
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/AnimatedFlex/index.js